module.exports = __webpack_public_path__ + "static/media/sub_sec_sto.1ab39781.png";